import React from "react";
import { Form, ListGroup, Spinner } from "react-bootstrap";
import InputComponent from "../UI/InputComponent/InputComponent";
import MultiUpload from "../UI/Upload/MultiUpload";
import ModalComponent from "../UI/Modal/Modal";
import ButtonComponent from "../UI/ButtonComponent/ButtonComponent";
import "./StrucnaUsavrsavanja.css";
import { PaperClipOutlined,  DeleteOutlined, CheckCircleOutlined, CloseCircleOutlined} from "@ant-design/icons";
import DatepickerComponent from "../UI/DatePicker/DatepickerComponent";
import moment from "moment";
import { ObavijestTemplateView } from "./ObavijestTemplateView";

const unosObavijesti = (props) => {

  const disableEndDate = (current) => {
    return current.isBefore(moment(props.datPocStrUsv)) || current.isBefore(moment(props.unosObavijestiData.absenceStart, "DD.MM.YYYY").add(6, 'months'));
  }

  const disableStartDate = (current) => {
    return current.isBefore(moment(props.datPocStrUsv)) || current.isAfter(moment(props.datZavStrUsv))
    || current >= moment(props.unosObavijestiData.absenceEnd, "DD.MM.YYYY");
  }

  return (
    <>
      <ModalComponent
        key="obavijest-modal"
        show={props.obavijestModal}
        onHide={props.hideModalObavijest}
        size="l"
        centered
        style={{ zIndex: "999999" }}
        title="Obavijest o nemogućnosti ispunjavanja obveze stalnog stručnog usavršavanja"
      >
        <Form onSubmit={props.obavijestSubmitHandler}>
          <div className="napomena-date-picker-wrapper">
            <DatepickerComponent
              id="absenceStart"
              index={{id:"absenceStart"}}
              controlLabel={"Datum početka"}
              required
              value={props.unosObavijestiData.absenceStart}
              handleDayClick={props.datePickerHandler}
              disabledDate={disableStartDate}
              errorBorderColor={props.error && !props.unosObavijestiData.absenceStart && "red"}
            />

            <DatepickerComponent
              id="absenceEnd"
              index={{id:"absenceEnd"}}
              controlLabel={"Datum završetka"}
              required
              value={props.unosObavijestiData.absenceEnd}
              handleDayClick={props.datePickerHandler}
              disabledDate={disableEndDate}
              errorBorderColor={props.error && !props.unosObavijestiData.absenceEnd && "red"}
            />
          </div>

          <InputComponent
            id="napomena"
            value={props.unosObavijestiData.napomena}
            onChange={props.unosObavijestiInputHandler}
            controlLabel={"Napomena"}
            as="textarea"
            rows="3"
            style={
              props.error &&
              props.unosObavijestiData.napomena.length > 500 &&
              "red"
            }
          />

          <label>Obavijest*</label>
          <MultiUpload
            id="obavijest"
            //ako je nesto pokidano, do ovoga je!
            uploadKey="obavijest"
            onChange={props.uploadHandler}
            className="upload"
            selectedFiles={props.unosObavijestiData.selectedFiles}
            style={
              props.error &&
              props.unosObavijestiData.selectedFiles.length < 1 &&
              "red"
            }
          />
          {props.isListLoading && <Spinner  as="span" animation="border" size="sm" role="status"/>}
          {props.obavijesti.filter(ob => ob.sts === 1).length > 0 ? <div>Učitane obavijesti:</div> : null}
          <div style={{ paddingBottom: "10px" }}>
            {props.obavijesti &&
              props.obavijesti.map((obavijest, index) => (
                <ObavijestTemplateView props={props} obavijest={obavijest} index={index} status={1} key={Math.random()} className={`obavijest-list-group ${props.userRole === 'ROLE_SLUZBENIK' ? 'three-col' : ''}`}/>
              ))}
          </div>
          
           {props.obavijesti.filter(ob => ob.sts === 2).length > 0 ? <div>Odobrene</div> : null}
          <div style={{ paddingBottom: "10px" }}>
            {props.obavijesti &&
              props.obavijesti.map((obavijest, index) => (
                <ObavijestTemplateView props={props} obavijest={obavijest} index={index} status={2} key={Math.random()} className="obavijest-list-group no-col"/>
              ))}
          </div>

           {props.obavijesti.filter(ob => ob.sts === 3).length > 0 ? <div>Odbijene</div> : null}
          <div style={{ paddingBottom: "10px" }}>
            {props.obavijesti &&
              props.obavijesti.map((obavijest, index) => (
                <ObavijestTemplateView props={props} obavijest={obavijest} index={index} status={3} key={Math.random()} className="obavijest-list-group no-col"/>
              ))}
          </div>
          <div className="row" key={"button"}>
            <div className="col-md-6">
              <ButtonComponent type="submit" block={true} variant="primary">
                Potvrdi
              </ButtonComponent>
            </div>
            <div className="col-md-6">
              <ButtonComponent
                onClick={props.hideModalObavijest}
                block={true}
                variant="danger"
              >
                Odustani
              </ButtonComponent>
            </div>
          </div>
        </Form>
      </ModalComponent>
    </>
  );
};

export default unosObavijesti;
